<!-- 新增线上月票类型接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCodes": "2KKN6112",
                "ticketName": "0412WDL测试月票01",
                "price": 10.00,
                "timePeriod":
                {
                    "startTime": "2019-04-16 00:11:25",
                    "endTime": "2019-04-17 09:11:25"
                }

            },
            responseCode: {
                "data": {
                    "monthTicketConfigId": 529
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台新增线上月票类型",
                t_url: this.commonUrls.test + "addOnlineMonthTicketType",
                p_url: this.commonUrls.prod + "addOnlineMonthTicketType",
                precondition: "无",
                fitSystem: "云停车场,VEMS传统车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCodes', info2: '是', info3: 'String', info4: '停车场编号列表，全部车场必须包含于某个运营商车场权限中方可创建，多个以,隔开，如：A,B' },
                        { info1: 'vipType', info2: '否', info3: 'Integer', info4: 'VIP类型（2本地VIP，3外部VIP），默认为2，外部VIP需要手动开闸' },
                        { info1: 'isDynamicMode', info2: '否', info3: 'Integer', info4: '是否多位多车（0否，1是），“开启多位多车”后，可限制VIP车主的VIP车辆数，如可用车位数为2，车主绑定VIP车辆为3，则前2辆进场的车辆可视为VIP车辆，第三辆车则被视为临时车；若无勾选，系统将把VIP车主绑定的所有车牌对应车辆均视为VIP车辆。默认0' },
                        { info1: 'autoSwitchVip', info2: '否', info3: 'Integer', info4: '是否自动切换多位多车场内临时车转vip(0否,1是)。isDynamicMode=1时有效，默认0' },
                        { info1: 'dynamicFullLimit', info2: '否', info3: 'Integer', info4: '是否多位多车满位，同组在场车无法进入（0否，1是）。isDynamicMode=1时设置，默认0' },
                        { info1: 'openVipFullLimit', info2: '否', info3: 'Integer', info4: '是否开启vip满位控制,（0否,1是），满位控制指的是当停车场该月票在场车辆达到限制数目后，对后续的该月票类型进行限制入场，限制入场的车辆需手动确认放行，放行后的车辆依旧是月票车辆。默认0' },
                        { info1: 'vipFullLimitValue', info2: '否', info3: 'Integer', info4: 'vip满位阈值' },
                        { info1: 'isDatePrivilege', info2: '否', info3: 'Integer', info4: '月票生效的日期，是否区分日期（0不区分，1区分）。默认0' },
                        { info1: 'isTimePrivilege', info2: '否', info3: 'Integer', info4: '月票生效的时段，是否区分时间段（0不区分，1区分）。默认0' },
                        { info1: 'privilegedateList', info2: '否', info3: 'String', info4: 'VIP有效日期，isDatePrivilege=1时必填,格式：yyyy-MM-dd，使用‘,’分割。例：“2019-01-01,2019-01-02”' },
                        { info1: 'privilegeTimePeriod', info2: '否', info3: 'String', info4: 'VIP有权限时间段，isTimePrivilege=1时必填，格式mm:ss-mm:ss' },
                        { info1: 'vipFullOpenModel', info2: '否', info3: 'Integer', info4: 'VIP满位放行模式（0有空位自动放行，无空位手动放行按VIP计费 1有空位自动放行，无空位手动放行按临时车计费 2无空位自动放行，按临时车计费）。默认0' },
                        { info1: 'vipNearExpiredDayThreshold', info2: '否', info3: 'Integer', info4: 'VIP临过期提示天数阈值，小于等于此阈值将提示。默认10' },
                        { info1: 'vipDeleteExpiredDayThreshold', info2: '否', info3: 'Integer', info4: '超期删除时长,单位：天。默认0' },
                        { info1: 'isChargeGroupRelated', info2: '否', info3: 'Integer', info4: '是否关联收费组(0否,1是，默认为否)' },
                        { info1: 'chargeGroupCode', info2: '否', info3: 'String', info4: '收费组编号' },
                        { info1: 'ticketName', info2: '是', info3: 'String', info4: '月票名称' },
                        { info1: 'renewFormerDays', info2: '否', info3: 'Integer', info4: '允许车主购买该月票时，向前续费相应的天数。0表示不允许向前续费。默认0' },
                        { info1: 'renewMethod', info2: '否', info3: 'Integer', info4: '续费方式，对内月票才有，0自然月，1自定义（允许车主自定义选择续费时间，价格按照天数去计算。如月票单价300元，每天则为10元。）默认0' },
                        { info1: 'price', info2: '是', info3: 'Decimal', info4: '单价' },
                        { info1: 'maxSellLimit', info2: '否', info3: 'Integer', info4: '最大销售数量限制，0无限，1有限。默认0' },
                        { info1: 'maxSellNum', info2: '否', info3: 'Integer', info4: '最大销售数量，maxSellLimit=1时必填' },
                        { info1: 'inviteCarTotal', info2: '否', info3: 'Integer', info4: '允许邀请车牌的总数量，允许车主添加相应数量的邀请车牌，一同使用该月票的收费规则。默认3' },
                        { info1: 'ticketDesc', info2: '否', info3: 'String', info4: '备注' },
                        { info1: 'remark', info2: '否', info3: 'String', info4: '月票简介' },
                        { info1: 'timePeriod', info2: '否', info3: 'JSONObject', info4: '有效时间段。vipType=3时必填' },
                        { info1: 'isContinuousRenewal', info2: '否', info3: 'Integer', info4: '移动端是否允许间断续费(1允许,0不允许)' },
                        { info1: 'singleBuyMinNumLimit', info2: '否', info3: 'Integer', info4: '限单次至少购买数(单位月)' },
                        { info1: 'singleBuyMaxNumLimit', info2: '否', info3: 'Integer', info4: '限单次至多购买数(单位月)' },
                        { info1: 'singleBuyNumLimitType', info2: '否', info3: 'Integer', info4: '限单次购买数类型(0单次，1时间范围)' },
                        { info1: 'singleBuyNumLimitValidFrom', info2: '否', info3: 'Integer', info4: '限单次购买数起始时间,(singleBuyNumLimitType=1时必填,singleBuyNumLimitType=0时非填,类型：yyyy-MM-dd)' },
                        { info1: 'singleBuyNumLimitValidTo', info2: '否', info3: 'Integer', info4: '限单次购买数截止时间,(singleBuyNumLimitType=1时必填,singleBuyNumLimitType=0时非填,类型：yyyy-MM-dd)' },
                        { info1: 'channelList', info2: '否', info3: 'JSONArray', info4: '通道权限列表' },
                        { info1: 'onlineRenew', info2: '否', info3: 'Integer', info4: '是否允许线上续费(0不允许，1允许，默认1)' },
                        { info1: 'onlineOpen', info2: '否', info3: 'Integer', info4: '是否允许线上开通(0不允许，1允许，默认1)' },
                        { info1: 'settlementType', info2: '否', info3: 'Integer', info4: '结算类型(0时间结算，1储值结算，2按次结算，3储时结算，默认为0)' },
                        { info1: 'vipIsInvalid', info2: '否', info3: 'Integer', info4: '有效期内，余值为0，VIP是否失效(结算类型为1/2/3时必填。0有效期内，余值为0，VIP无效，1有效期内，余值为0，VIP有效)' },
                        { info1: 'deductionType', info2: '否', info3: 'Integer', info4: '抵扣时间类型(0天,1小时,2分钟)' },
                        { info1: 'deductionTime', info2: '否', info3: 'Integer', info4: '根据deductionType，赋值x（deductionType=0抵扣x天,deductionType=1抵扣x小时,deductionType=2抵扣x分钟）' },
                        { info1: 'offLine', info2: '否', info3: 'Integer', info4: '离线月票0:不支持，1:支持' },
                        { info1: 'validAreaCodes', info2: '否', info3: 'JSONArray', info4: '有效区域列表' },


                ]
                },{
                    titleName: 'timePeriod',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'startTime', info2: '是', info3: 'String', info4: '起始时间，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'endTime', info2: '是', info3: 'String', info4: '结束时间，yyyy-MM-dd HH:mm:ss' }
                        ]
                },{
                    titleName: 'channelList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '车场编码' },
                        { info1: 'channelId', info2: '是', info3: 'Long', info4: '通道id（云车场专用）' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'monthTicketConfigId', info2: '是', info3: 'Long', info4: '月票类型id' },
                    ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/addOnlineMonthTicketType.vue